import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import BackdropLoader from '../General/Loader';
import SnackBar from '../General/SnackBar';
import { FetchAllUserRoles, FetchUserRoles, UpdateUserRole, UserRoleUpdate } from 'API/HrModule';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { IoCloseCircle } from 'react-icons/io5';
import { IoMdClose } from 'react-icons/io';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250
    }
  }
};

export default function ViewModal(props) {
  const [Data, setData] = React.useState([]);
  const [error, setError] = React.useState({ open: false, message: '', type: '' });
  const [IsLoading, setIsLoading] = React.useState(false);
  const [SelectedRole, setSelectedRole] = React.useState([]);
  const [UserRoles, setUserRoles] = React.useState([]);

  const handleChange = (event) => {
    const {
      target: { value }
    } = event;
    setSelectedRole(
      // On autofill we get a stringified value.
      typeof value === 'string' ? value.split(',') : value
    );
  };

  const HandleAlertOpen = (message, type) => {
    setError({ open: true, message: message, type: type });
  };

  const HandleAlertClose = () => {
    setError({ open: false, message: '', type: '' });
  };

  const HandleGet = () => {
    if (props.type && (props.type === 'view' || props.type === 'edit')) {
      FetchUserRoles(props.data.id, setIsLoading, setUserRoles, HandleAlertOpen, props.handleClose, props.handleGet);
    }
  };

  useEffect(() => {
    if (props.open) {
      FetchAllUserRoles(setIsLoading, setData, HandleAlertOpen);
      HandleGet();
    } else {
      setData([]);
      setSelectedRole([]);
    }
  }, [props.open]);

  const handleAssignRole = () => {
    if (props.type && props.type === 'view') {
      return;
    }
    if (SelectedRole === '' || SelectedRole === 'select' || (Array.isArray(SelectedRole) && SelectedRole.length === 0)) {
      HandleAlertOpen('Please select a role', 'error');
      return;
    }
    UpdateUserRole(props.data.id, SelectedRole, setIsLoading, HandleAlertOpen, props.handleClose, props.handleGet);
  };

  const handleRemove = (id) => {
    UserRoleUpdate(props.data.id, [id], 'remove', setIsLoading, HandleAlertOpen, HandleGet);
  };

  return (
    <React.Fragment>
      <BackdropLoader open={IsLoading} />
      <SnackBar open={error.open} handleClose={HandleAlertClose} message={error.message} type={error.type} />
      <Dialog open={props.open} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" maxWidth="xs" fullWidth>
        <Box
          sx={{ position: 'absolute', top: '10px', right: '10px', cursor: 'pointer', fontSize: '24px', zIndex: 10 }}
          onClick={props.handleClose}
        >
          <IoCloseCircle />
        </Box>
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h4">User Role</Typography>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.type && props.type === 'view' ? (
              <Box sx={{ display: 'flex', gap: '10px' }}>
                {UserRoles && UserRoles.length > 0 ? (
                  UserRoles.map((role, index) => (
                    <Box
                      key={index}
                      sx={{
                        backgroundColor: '#f0f0f0',
                        padding: '5px 10px',
                        borderRadius: '5px',
                        fontSize: '16px'
                      }}
                    >
                      {role.usertype}
                    </Box>
                  ))
                ) : (
                  <Box
                    sx={{
                      backgroundColor: '#f0f0f0',
                      padding: '5px 10px',
                      borderRadius: '5px',
                      fontSize: '16px'
                    }}
                  >
                    No roles assigned
                  </Box>
                )}
              </Box>
            ) : props.type && props.type === 'edit' ? (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                <Box
                  sx={{
                    display: 'flex',
                    gap: '8px',
                    flexWrap: 'wrap', // Allows wrapping if too long
                    backgroundColor: '#fff',
                    padding: '10px',
                    borderRadius: '8px',
                    border: '1px solid #ccc'
                  }}
                >
                  {UserRoles?.length > 0 &&
                    UserRoles.map((role, index) => (
                      <Box
                        key={index}
                        sx={{
                          backgroundColor: '#f0f0f0',
                          padding: '5px 10px',
                          borderRadius: '5px',
                          fontSize: '14px',
                          color: '#333',
                          display: 'flex',
                          gap: '20px',
                          alignItems: 'center',
                          fontWeight: '500'
                        }}
                      >
                        {role.usertype}
                        <IoMdClose style={{ cursor: 'pointer' }} onClick={() => handleRemove(role.usertype)} />
                      </Box>
                    ))}
                </Box>

                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  multiple
                  value={SelectedRole ? SelectedRole : 'select'}
                  renderValue={(selected) =>
                    selected
                      .map((id) => {
                        const role = Data.find((r) => r.usertype === id);
                        return role ? role.display_name : id;
                      })
                      .join(', ')
                  }
                  onChange={handleChange}
                  MenuProps={MenuProps}
                >
                  <MenuItem value="select">
                    <em>Select</em>
                  </MenuItem>
                  {Data.map((role) => (
                    <MenuItem key={role._id} value={role.usertype}>
                      {role.display_name}
                    </MenuItem>
                  ))}
                </Select>
              </Box>
            ) : (
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  multiple
                  value={SelectedRole ? SelectedRole : 'select'}
                  renderValue={(selected) =>
                    selected
                      .map((id) => {
                        const role = Data.find((r) => r.usertype === id);
                        return role ? role.display_name : id;
                      })
                      .join(', ')
                  }
                  onChange={handleChange}
                  MenuProps={MenuProps}
                >
                  <MenuItem value="select">
                    <em>Select</em>
                  </MenuItem>
                  {Data.map((role) => (
                    <MenuItem key={role._id} value={role.usertype}>
                      {role.display_name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button
            sx={{
              backgroundColor: '#688B2A',
              color: '#fff',
              borderRadius: '10px',
              padding: '5px 20px',
              visibility: props.type && props.type === 'view' ? 'hidden' : 'visible',
              '&:hover': {
                backgroundColor: '#688B3A',
                color: '#fff',
                borderRadius: '10px'
              }
            }}
            onClick={handleAssignRole}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
